import React from 'react'

import { Autorenew } from '@mui/icons-material'
import FilterButton from '../../../components/buttons/FilterButton'

const SyncronizarOpenButton = ({ ...props }) => (
  <FilterButton
    color="white"
    {...props}
    Icon={Autorenew}
    text="Sincronizar Leitor"
  />
)
export default SyncronizarOpenButton
